import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { api } from "@/lib/api";
import { Reveal } from "@/components/site/Reveal";
import { Marquee } from "@/components/site/Marquee";
import { VideoReel } from "@/components/site/VideoReel";
import { MEDIA } from "@/data/media";

export default function Gallery() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/gallery").then((r) => setItems(r.data)).catch(() => {}); }, []);

  return (
    <div className="pt-32">
      <section className="px-5 sm:px-8 pb-12">
        <div className="max-w-[1400px] mx-auto">
          <Reveal><p className="text-xs uppercase tracking-[0.3em] text-forest mb-6">Gallery</p></Reveal>
          <Reveal delay={0.1}><h1 className="font-sans font-extrabold tracking-tight text-5xl sm:text-7xl leading-[1.02] max-w-3xl">See it, feel it, book it.</h1></Reveal>
          <Reveal delay={0.2}><p className="text-ink/60 text-lg mt-6 max-w-2xl">A look at the booth, the moments, and the finished films. Placeholder shots for now — real event photography lands here as we book.</p></Reveal>
        </div>
      </section>

      <section className="px-5 sm:px-8 pb-16">
        <div className="max-w-[1200px] mx-auto">
          <Reveal>
            <VideoReel url={MEDIA.reelEmbedUrl} poster={MEDIA.reelPoster} length={MEDIA.reelLength} heightClass="h-[320px] sm:h-[540px]" />
          </Reveal>
        </div>
      </section>

      <Marquee text="Real moments · Analog memories" />

      <section className="px-5 sm:px-8 py-20">
        <div className="max-w-[1400px] mx-auto grid sm:grid-cols-2 lg:grid-cols-3 gap-x-5 gap-y-10">
          {items.map((g, i) => {
            const tilt = [-5, 4, -3, 6, -4, 3, -6, 2][i % 8];
            return (
              <motion.div
                key={g.id || i}
                initial={{ opacity: 0, y: 70, x: i % 2 ? -50 : 50, rotate: tilt * 3.2, scale: 0.88 }}
                whileInView={{ opacity: 1, y: 0, x: 0, rotate: tilt, scale: 1 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.85, delay: (i % 3) * 0.1, ease: [0.22, 1, 0.36, 1] }}
                whileHover={{ rotate: 0, y: -10, scale: 1.04, zIndex: 20, boxShadow: "0 30px 60px -25px rgba(26,79,54,0.5)" }}
                className="clip-frame overflow-hidden border border-clubborder bg-white p-2 relative"
                data-testid={`gallery-item-${i}`}
              >
                <div className="overflow-hidden clip-frame relative">
                  <img src={g.url} alt={g.caption} className="filmed w-full h-64 object-cover" />
                  <span className="absolute bottom-2 left-2 bg-cream/90 text-forest text-xs px-3 py-1 rounded-full">{g.tag}</span>
                </div>
                <p className="font-serif italic text-lg px-1 pt-3 pb-1">{g.caption}</p>
              </motion.div>
            );
          })}
        </div>
      </section>

      <section className="px-5 sm:px-8 pb-24 text-center">
        <Reveal><Link to="/book" className="inline-block rounded-full bg-forest text-cream px-10 py-4 text-base hover:bg-forest-deep transition-colors">Check Your Date</Link></Reveal>
      </section>
    </div>
  );
}
